jQuery(function ($) {
	// Header
	function changeHeader() {
		if ( scrollY > 50 ) {
			$('#top-bar-menu.is-homepage').removeClass('alt-header');
			$('#top-bar-mobile-menu.is-homepage').removeClass('alt-header');
		} else {
			$('#top-bar-menu.is-homepage').addClass('alt-header');
			$('#top-bar-mobile-menu.is-homepage').addClass('alt-header');
		}
	}

	changeHeader();
	$(document).on('scroll', function () {
		changeHeader();
	});

	$('#top-bar-mobile-menu .menu-burger.open').click(function () {
		$('#top-bar-mobile-menu .mobile-dropdown').show();

		if ( $(document).width() <= 480 ) {
			$('body').css('position', 'fixed');
		}
	});

	$('#top-bar-mobile-menu .menu-burger.close').click(function () {
		$('#top-bar-mobile-menu .mobile-dropdown').hide();
		if ( $(document).width() <= 480 ) {
			$('body').css('position', 'static');
		}
	});

	if ( $(window).width() < 1210 ) {
		addDropdown($('.top-bar.is-homepage #main-nav'));
		addDropdown($('.mobile-dropdown #main-nav'));
	}

	function addDropdown (nav) {
		nav.find('li.menu-item-has-children').append('<div class="dropdown-arrow"></div>');

		nav.on('click', '.dropdown-arrow', function () {
			if ( $(this).prev().hasClass('open-dropdown') ) {
				$(this).prev().removeClass('open-dropdown');
			} else {
				nav.find('li.menu-item-has-children ul.menu').removeClass('open-dropdown');
				$(this).prev().addClass('open-dropdown');
			}
		});
	}

    /**
	 *
	 * Show minicart Price after timeout
     */

    setTimeout( function(){
        $('.mini-cart-link .amount').addClass('vet-loaded');
	}, 1000);


});